import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, DataStatus, LL_V_L, Thunder, Button, TS_Input } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_AdvisorATS } from './module/ModuleFE_AdvisorATS.js';
import { _keys, arrayToMap, mergeObject, RuntimeModules } from '@nu-art/ts-common';
import { ModuleSyncType } from '@nu-art/thunderstorm-frontend/modules/db-api-gen/types';
import { ModuleFE_CSVParser } from '@nu-art/thunderstorm-frontend/modules/ModuleFE_CSVParser';
import JSZip from 'jszip';
import { HeaderKey_ContentType } from '@nu-art/thunderstorm-shared';
export class ATS_ZippedCSV extends ComponentSync {
    static screen = { name: `DevTool - ZippedCSV`, renderer: this };
    static defaultProps = {
        modules: [],
        pageTitle: () => this.screen.name
    };
    deriveStateFromProps(nextProps, state = {}) {
        return state;
    }
    constructor(p) {
        super(p);
    }
    render() {
        return _jsxs(LL_V_L, { children: [_jsx(TS_Input, { value: this.state.backupId, onAccept: (backupId) => this.setState({ backupId }), type: "text" }), _jsx(Button, { onClick: async () => {
                        const response = await ModuleFE_AdvisorATS.api.createAdvisorArtifact({ backupId: this.state.backupId }).executeSync();
                        await this.loadFromSignedUrl(response.signedUrl);
                    }, children: "Kaki Gadol" })] });
    }
    getModulesToSync = () => RuntimeModules().filter((module) => module.syncType === ModuleSyncType.APISync);
    async loadFromSignedUrl(url) {
        const modules = arrayToMap(this.getModulesToSync(), i => i.dbDef.dbKey);
        const start = performance.now();
        const itemsToSync = [];
        const errors = [];
        this.logInfo('Loading Artifact from Url');
        const response = await fetch(url);
        if (!response.ok) {
            this.logError(`Failed to fetch file from URL: ${url}`);
            return;
        }
        // Step 1: Load the ZIP file
        this.logInfo('Load response to array buffer');
        const zipData = await response.arrayBuffer();
        this.logInfo('Unzip');
        const zip = await JSZip.loadAsync(zipData);
        // Step 2: Find and extract the CSV file
        this.logInfo('turning to a csv file');
        const csvFile = zip.file(/\.csv$/i)?.[0];
        if (!csvFile) {
            this.logError('No CSV file found in the zip archive');
            return;
        }
        this.logInfo('Loading the csv file into string mem');
        const csvContent = await csvFile.async('text'); // Extract CSV as a string
        this.logInfo('Loading the csv file into rtdb');
        const config = {};
        await new Promise(resolve => {
            const isEmulator = Thunder.getInstance().getConfig().label?.toLowerCase() === 'local';
            const downloadRequestHeaders = isEmulator ? undefined : { [HeaderKey_ContentType]: 'text/csv' };
            const finalConfig = config ? mergeObject({ downloadRequestHeaders }, config) : { downloadRequestHeaders };
            ModuleFE_CSVParser.fromString(csvContent, {
                transform: (value, field) => field === 'document' ? JSON.parse(value) : value,
                step: async (results, parser) => {
                    if (results.errors?.length)
                        return errors.push(...results.errors);
                    const item = results.data;
                    const module = modules[item.dbKey];
                    if (!module)
                        return;
                    itemsToSync.push(item);
                },
                complete: async (results) => {
                    for (const moduleKey of _keys(modules)) {
                        const items = itemsToSync.filter(item => item.dbKey === moduleKey);
                        const module = modules[moduleKey];
                        // this.logInfo(`Syncing ${items.length} items to ${moduleKey}`);
                        await module.IDB.syncIndexDb(items.map(item => item.document));
                        await module.cache.load();
                        module.setDataStatus(DataStatus.ContainsData);
                    }
                    const end = performance.now();
                    this.logInfo(`sync took ${((end - start) / 1000).toFixed(3)} seconds`);
                    if (errors.length)
                        this.logError('Parsed with errors', ...errors);
                    resolve();
                },
                ...finalConfig,
                error: (error) => {
                    this.logError(`CSV Parsing failed`, error);
                }
            });
        });
        this.logInfo('Loaded csv file');
    }
    ;
}
//# sourceMappingURL=ATS_ZippedCSV.js.map